import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { FoodCart, FoodCartItem, FoodCartRequest, StoreMetaInfo } from '../../models/cart-models';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { HelperService } from '../helper/helper.service';
import { EnvironmentConfigService } from '../shared/environment-config.service';
@Injectable({
  providedIn: 'root'
})
export class CartService {
  // tslint:disable-next-line: variable-name
  private _foodCart: FoodCart;

  foodCartSubject = new Subject<FoodCart>();
  storeMetaInfo: StoreMetaInfo;
  apiConfig = {
    baseUrl: 'https://api2.travelx.ai',
    updateCartStatePath: '/api/updateCartState',
    getCartListPath: '/api/getCartList',
    checkoutCartPath: '/api/checkoutcart'
  };
  // http://api.travelx.ai/api/getCartList?key=qw1op5cv8j0d&pid=gmr&dpi=480&platform=android&deviceid=PWA1IW0LZeKCB&airportid=1&novalidation=1&ptype=food

  apiParams: any;
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    })
  };

  constructor(private activatedRoute: ActivatedRoute, private httpClient: HttpClient, private helperService: HelperService, private envService: EnvironmentConfigService) {
    this.initApiParams();
    this.foodCartSubject.subscribe((newCartData) => {
      if (newCartData.list.length === 0) {
        this.clearFoodCart();
      } else {
        this.foodCart = newCartData; // updating actual cart state
      }
    });
  }
  // tslint:disable-next-line: max-line-length
  // http://api.travelx.ai/api/addtoCart?key=qw1op5cv8j0d&pid=gmr&uuid=a1f0027c-dd5e-4bd4-8855-d1e3a14d826e&platformid=34912c9c7e3d1feb&dpi=480&platform=android&location_id=5219&flightid=OD+206&ondate=2019-06-17&ptype=food&storeid=3232&deviceid=34912c9c7e3d1feb&airportid=1&novalidation=1&isfirst=1

  initApiParams() {
    this.apiParams = {
      novalidation: 1,
      ptype: 'food',
    };
  }

  initializeCartData(apiResponse: FoodCartItem[], storeId, locationId): FoodCart {
    if (typeof this.foodCart.locationId === 'undefined' || this.foodCart.locationId === parseInt(locationId, 10)) {
      let retrievdFoodCart: FoodCart = { list: [] } as FoodCart;
      retrievdFoodCart.locationId = parseInt(locationId, 10);
      retrievdFoodCart.storeId = parseInt(storeId, 10);
      retrievdFoodCart.list = apiResponse;
      this.foodCart = retrievdFoodCart;
    }
    return this.foodCart;
  }

  public updateFoodCart(newCartData): Observable<any> {
    const foodCartRequestObj = new FoodCartRequest(newCartData);
    if (this.guestId !== null) {
      this.apiParams.isfirst = 0;
      this.apiParams.guestid = this.guestId;
    } else {
      this.apiParams.isfirst = 1;
    }
    if (this.guestDeviceId !== null) {
      this.apiParams.deviceid = this.guestDeviceId;
    }
    this.apiParams.location_id = newCartData.locationId;
    this.apiParams.storeid = newCartData.storeId;
    return this.httpClient.post<any>(this.cartStateApi, foodCartRequestObj, this.httpOptions);
  }

  async addMenuItem(cartItem: FoodCartItem, storeId: number, locationId: number, clearcart: number = 0, updateCartId: number = null): Promise<boolean> {
    let newFoodCart: FoodCart;
    if (clearcart === 0) {
      newFoodCart = { ...this.foodCart };
      if (typeof newFoodCart.storeId === 'undefined') {
        newFoodCart = {
          storeId,
          locationId,
          list: [] as FoodCartItem[]
        } as FoodCart;
      }
    } else {
      newFoodCart = {
        storeId,
        locationId,
        list: [] as FoodCartItem[]
      } as FoodCart;
    }

    if (newFoodCart.list && newFoodCart.list.length > 0) {
      if (updateCartId !== null) {
        // get the index of the cart item which matches the updatecartId and splice
        const updateCartIndex = newFoodCart.list.findIndex((item) => {
          return item.cartId === updateCartId;
        });
        if (updateCartIndex >= 0 && newFoodCart.list[updateCartIndex].quantity > 0) {
          cartItem.quantity = newFoodCart.list[updateCartIndex].quantity;
          newFoodCart.list.splice(updateCartIndex, 1, cartItem);
        } else {
          newFoodCart.list.push(cartItem);
        }
      } else {
        const optionListStr = cartItem.optionList ? JSON.stringify(cartItem.optionList.sort()) : '[]';
        const cartIndex = newFoodCart.list.findIndex((item) => {
          if (item.optionList === null || typeof item.optionList === 'undefined' || item.optionList.length === 0) {
            return item.id === cartItem.id;
            // item.optionList = [];
          }
          return optionListStr === JSON.stringify(item.optionList.sort());
        });
        if (cartIndex >= 0 && newFoodCart.list[cartIndex].quantity > 0) {
          newFoodCart.list[cartIndex].quantity++;
          // newFoodCart.list[cartIndex].optionList = newFoodCart.list[cartIndex].optionList.concat(cartItem.optionList);
          newFoodCart.list[cartIndex].price += cartItem.price;
          // this.foodCartSubject.next(this.foodCart);
          // return;
        } else {
          // for adding new fresh item
          newFoodCart.list.push(cartItem);
        }
      }
    } else {
      newFoodCart.list.push(cartItem);
    }
    // tslint:disable-next-line: prefer-const
    try {
      const response = await this.updateFoodCart(newFoodCart).toPromise();
      if (response.status) {
        if (this.guestId == null && localStorage.getItem('userId') == null) {
          this.guestId = response.guestId;
        }

        if (this.guestDeviceId == null) {
          this.guestDeviceId = response.guestDeviceId;
        }
        let newFoodCartItems: FoodCartItem[] = [];
        if (response.cartDetails.length > 0) {
          response.cartDetails.forEach(element => {
            newFoodCartItems.push(element as FoodCartItem);
          });
        }
        newFoodCart.list = newFoodCartItems;
        this.foodCartSubject.next(newFoodCart);
        return true;
      } else {
        return false; // API failed for some reason.
      }
    } catch (error) {
      return false; // exception caught.
    }
    return;
  }

  public getCartList(ptype: string) {
    this.apiParams.ptype = ptype;
    if (this.guestId !== null) {
      this.apiParams.guestid = this.guestId;
    }
    if (this.guestDeviceId !== null) {
      this.apiParams.deviceid = this.guestDeviceId;
    }
    // this.apiParams.airport = this.airportService.getSelectedAirport();
    return this.httpClient.get<any>(this.getCartListApi);
  }

  public getQuantityByMenuId(menuId): number {

    let itemQuantity = 0;
    if (typeof this.foodCart.list !== 'undefined') {
      this.foodCart.list.forEach((element) => {
        if (element.id === menuId) {
          itemQuantity += element.quantity;
        }
      });
    }
    return itemQuantity;
  }

  public async removeCartItemById(cartItem): Promise<boolean> {
    let newFoodCart = { ...this.foodCart };
    const menuId = cartItem.id;
    const optionListStr = cartItem.optionList ? JSON.stringify(cartItem.optionList.sort()) : '[]';
    newFoodCart.list = newFoodCart.list.filter((element, index) => {
      if (element.optionList === null) {
        element.optionList = [];
      }
      if (element.id === menuId && optionListStr === JSON.stringify(element.optionList.sort())) {
        if (element.quantity > 1) {
          newFoodCart.list[index].quantity--;
          return true;
        }
        return false;
      } else {
        return true;
      }
    });
    try {
      let response = await this.updateFoodCart(newFoodCart).toPromise();
      if (response.status) {
        this.foodCartSubject.next(newFoodCart);
        return true;
      } else {
        return false;
      }
    } catch (error) {
      return false;
    }
  }

  public checkoutCart(userInfo) {
    this.apiParams.location_id = this.foodCart.locationId;
    // this.apiParams.airportid = '';
    let cartIds = '';
    this.foodCart.list.forEach((item) => {
      if (cartIds === '') {
        cartIds = item.cartId.toString();
      }
      cartIds = cartIds + ',' + item.cartId;
    });
    this.apiParams.cartids = cartIds;
    this.apiParams.name = userInfo.Name;
    this.apiParams.email = userInfo.Email;
    this.apiParams.phone = userInfo.number;
    this.apiParams.storeid = this.foodCart.storeId;
    this.apiParams.deviceid = this.guestDeviceId;
    this.apiParams.platformid = this.guestDeviceId;
    this.apiParams.guestid = this.guestId;
    this.apiParams.version = 2;
    /*     this.apiParams.flightid = flightid;
        this.apiParams.ondate = ondate;
        this.apiParams.datetime = datetime;
     */
    return this.httpClient.get<any>(this.checkoutCartApi);
  }

  public async clearCart() {
    const newFoodCart = { ...this.foodCart };
    newFoodCart.list = [] as FoodCartItem[];
    const response = await this.updateFoodCart(newFoodCart).toPromise();
    if (response.status) {
      this.foodCartSubject.next(newFoodCart);
      return true;
    } else {
      return false; // API failed for some reason.
    }
  }

  // getter setter mothods




  public set guestId(value: string) {
    localStorage.setItem('guestId', value);
  }

  public get guestId(): string {
    return localStorage.getItem('guestId');
  }

  public set guestDeviceId(value: string) {
    localStorage.setItem('guestDeviceId', value);
  }

  public get guestDeviceId(): string {
    return localStorage.getItem('guestDeviceId');
  }

  public get cartStateApi(): string {
    let detaultParams = this.envService.getDefaultApiParams();
    if (typeof detaultParams.userid !== 'undefined') {
      delete this.apiParams.guestid;
      delete this.apiParams.isfirst;
    }
    let finalRequestParams = { ...detaultParams, ...this.apiParams };
    // tslint:disable-next-line: max-line-length
    return this.cartStateApi = `${this.envService.updateCartStateApi()}?${this.helperService.serializeToGetParams(finalRequestParams)}`;
  }

  public set cartStateApi(value: string) {
  }

  public get checkoutCartApi(): string {
    let detaultParams = this.envService.getDefaultApiParams();
    if (typeof detaultParams.userid !== 'undefined') {
      delete this.apiParams.guestid;
      delete this.apiParams.isfirst;
    }
    let finalRequestParams = { ...detaultParams, ...this.apiParams };
    // tslint:disable-next-line: max-line-length
    return this.checkoutCartApi = `${this.envService.checkoutCartApi()}?${this.helperService.serializeToGetParams(finalRequestParams)}`;
  }

  public set checkoutCartApi(value: string) {
  }

  public get getCartListApi(): string {
    let detaultParams = this.envService.getDefaultApiParams();
    if (typeof detaultParams.userid !== 'undefined') {
      delete this.apiParams.guestid;
      delete this.apiParams.isfirst;
    }
    let finalRequestParams = { ...detaultParams, ...this.apiParams };
    // tslint:disable-next-line: max-line-length
    return this.getCartListApi = `${this.envService.getCartListApi()}?${this.helperService.serializeToGetParams(finalRequestParams)}`;
  }

  public set getCartListApi(value: string) {
  }

  public clearFoodCart() {
    this._foodCart = {} as FoodCart;
    localStorage.removeItem('foodCart');
  }

  public get foodCart(): FoodCart {
    return JSON.parse(localStorage.getItem('foodCart')) as FoodCart || { list: [] } as FoodCart;
  }

  public set foodCart(value: FoodCart) {

    localStorage.setItem('foodCart', JSON.stringify(value));
    this._foodCart = value;
  }
}
